import React from 'react';
import { ConfiguratorGroupDto } from '@/services/configurator';
import { useOptionConfigurator } from '../../OptionConfiguratorContext';
import { RoomOptionAccordionList } from './RoomOptionAccordionList';
import { RoomOptionTwoTierList } from './RoomOptionTwoTierList';

export interface RoomOptionMenuProps {
    groups: ConfiguratorGroupDto[];
    is3d?: boolean;
    /** Fired when a group is expanded/opened — used to pre-load that group's configurator visuals. */
    onGroupExpand?: (group: ConfiguratorGroupDto) => void;
    /** Two-tier only: fired when the open group changes (null when none). */
    onActiveGroupChange?: (group: ConfiguratorGroupDto | null) => void;
}

/**
 * Picks the options-menu interaction model. The immersive presentation (showroom + the authenticated
 * `/options/configurator` route) uses the two-tier list (group list -> per-group option view); the
 * standard buyer/seller configurator uses the accordion (expand-in-place).
 */
export const RoomOptionMenu: React.FC<RoomOptionMenuProps> = (props) => {
    const { immersive } = useOptionConfigurator();

    if (immersive) {
        return <RoomOptionTwoTierList {...props} />;
    }

    // The accordion has no per-group "active" concept — drop the two-tier-only callback.
    const { onActiveGroupChange: _onActiveGroupChange, ...accordionProps } = props;
    return <RoomOptionAccordionList {...accordionProps} />;
};
